<template>
  <div class="page">
    <van-nav-bar
      title="实习申请"
      left-arrow
      @click-left="$router.go(-1)"
      z-index="99999"
      fixed
      :placeholder="true"
      :safe-area-inset-top="true"
    />
    <van-tabs
      type="line"
      v-model="active"
      animated
      color="#0088F8"
      @click="tabsChange"
    >
      <van-tab title="按教师汇总统计">
          <div class="exchange">
          <div
            class="item"
            v-for="(item, index) of lstJsList"
            :key="index"
          >
            <ul>
              <li class='curpepother'><span>学年学期</span>{{ item.xnxq01id }}</li>
              <li class='curpepother'><span>教师工号</span>{{ item.jgh }}</li>
              <li class='curpepother'><span>教师姓名</span>{{ item.xm }}</li>
              <li class='curpepother'><span>所属学院</span>{{ item.ssxy }}</li>
              <li class='curpepother'><span>平均分</span>{{ item.pjf }}</li>
            </ul>
          </div>
        </div>
      </van-tab>
      <van-tab title="按教师/课程汇总查看">
        <div class="exchange">
          <div
            class="item"
            v-for="(item, index) of lstJskcList"
            :key="index"
          >
            <ul>
              <li class='curpepother'><span>学年学期</span>{{ item.xnxqh01id }}</li>
              <li class='curpepother'><span>教师工号</span>{{ item.jgh }}</li>
              <li class='curpepother'><span>教师姓名</span>{{ item.xm }}</li>
              <li class='curpepother'><span>所属学院</span>{{ item.ssxy }}</li>
              <li class='curpepother'><span>课程</span>{{ item.kc }}</li>
              <li class='curpepother'><span>平均分</span>{{ item.pjf }}</li>
            </ul>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
  <script>
  import { Api } from "@/utils/axios";
  export default {
	data() {
	  return {
      route_query:{},
      lstJsList:[],
      lstJskcList:[]
	  };
	},
	mounted() {
		this.route_query = JSON.parse(decodeURI(this.$route.params.route_params));
		this.getList(this.route_query);
	},
	methods: {
	  // 获取课程列表
	  async getList(query) {
		 const params = {
		   xnxq: query.xnxqId
		  }
		const res = await Api.getpjjgList(params);
		this.lstJsList = res.data.lstJs;
    this.lstJskcList = res.data.lstJskc;
	  }
	}
  };
  </script>
  <style lang="less" scoped>
  .img-icon {
    height: 20px;
  }
  .van-tabs__line {
    background-color: #0088f8 !important;
    width: 25px;
  }
  .van-tab--active {
    color: #333333 !important;
    font-weight: 600 !important;
  }
  .page {
    min-height: 100vh;
    background: #f2f2f4;
    margin-top: -50px;
    .bblock {
      height: 40px;
      background: #f2f2f4;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      letter-spacing: 0;
      margin-left: 15px;
      line-height: 50px;
    }
  }
  .van-field__label {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 16px !important;
    span {
      color: #333333 !important;
    }
  }
  .button-box {
    width: 100%;
    height: 70px;
    background: #ffffff;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .van-button {
    width: 165px;
    height: 50px;
    border: 1px solid #e5e5e5;
    border-radius: 25px !important;
  }
  .apply-pop {
    width: 100%;
    position: fixed;
    bottom: 0;
    background-color: @attendance-color-3;
    box-sizing: border-box;
    border-radius: 5px 5px 0 0;
    max-height: 40%;
    overflow-y: scroll;
  }

  .pop-title {
    display: flex;
    justify-content: space-between;
    padding: 13px;
    position: fixed;
    width: 100%;
    background-color: @attendance-color-3;
    box-sizing: border-box;
    border-radius: 5px 5px 0 0;
    z-index: 9;
  }
  .pop-title i {
    width: 22px;
    height: 22px;
    background-size: 22px 22px;
  }
  .person {
    padding: 20px 20px 0;
    display: flex;
    flex-wrap: wrap;
    margin-top: 48px;
  }
  .person button {
    border-radius: 3px;
    padding: 5px 15px;
    margin-right: 12px;
    margin-bottom: 15px;
  }
  .apply-pop .person .per-btn {
    background-color: @attendance-background-color-7;
    color: @attendance-background-color-1;
  }
  .person .cur {
    background-color: @attendance-background-color-1;
    color: @attendance-background-color-7;
  }
  /deep/.van-dropdown-menu__bar {
    height: 0 !important;
    opacity: 0 !important;
  }
  .exchange {
	  padding: 1% 3% 0;
	  overflow: auto;
	  height: 90vh;
	  .item {
		background: #f8f8f8;
		border-radius: 5px;
		margin: 0 auto 3%;
		padding: 3% 0 3% 3%;
		box-sizing: border-box;
		p {
		  height: 22px;
		  font-family: PingFangSC-Medium;
		  font-size: 16px;
		  color: #212f6e;
		  letter-spacing: 0;
		  font-weight: bolder;
		  margin-bottom: 2%;
		}
		span {
		  height: 22px;
		  font-family: PingFangSC-Medium;
		  font-size: 16px;
		  color: #212f6e;
		  letter-spacing: 0;
		  font-weight: bolder;
		  margin-bottom: 2%;
		}
		ul {
		  li .curpepother{
			height: 16px;
			font-family: PingFangSC-Medium;
			font-size: 14px;
			color: #757da3;
			letter-spacing: 0;
			line-height: 16px;
			margin-bottom: 1%;
		  }
		}
		li .curpep {
		  height: auto;
			font-family: PingFangSC-Medium;
			font-size: 14px;
			color: #757da3;
			letter-spacing: 0;
			line-height: 16px;
			margin-bottom: 1%;
		}
	  }
	}
  </style>
  


// WEBPACK FOOTER //
// src/components/teacher/pjjgcx/pjjgcxList.vue